export default (axiosInstance, routerInstance, keycloak) => {
  if (keycloak) {
    // Note that "updateToken" will not throw if it fails to refresh the token with 400,
    // but will call this callback. Here we force a logout so that we get a new set of tokens.
    // Alternatively we could just let it try to refresh the tokens if the session is still valid
    // (Keycloak will redirect back to the current page automatically).
    // In some cases (at least with very short access token validity times) forcing the logout also
    // avoids an infinite redirection loop.
    keycloak.onAuthRefreshError = () => {
      console.log('Refresh token error, forcing logout.');
      console.log(window.location.href);
      keycloak.logout({redirectUri: window.location.href});
    };
  }
  axiosInstance.interceptors.request.use(
      async (config) => {
        if (keycloak) {
          // "updateToken" will *not* go through Axios so we're good here.
          const success = await keycloak.updateToken(10); // Refresh if less than 10s remaining from the access token
          if (success) {
            console.log('Token refreshed successfully.');
          }
          config.headers['Authorization'] = 'Bearer ' + keycloak.token;
          config.withCredentials = true;
          return config;
        } else {
          config.withCredentials = true;
          return config;
        }
      },
      (error) => {
        console.log('interceptor error: ', error);
        return Promise.reject(error);
      },
  );
  // axiosInstance.interceptors.response.use(
  //     (response) => response,
  //     (error) => {
  //       if (error.response?.status) {
  // const {status} = error.response;
  // switch (status) {
  // case 401:
  // case 403:
  // in case we have separate permissions
  // case 502:
  // case 504:
  //   routerInstance.replace({
  //     path: `/errors/${status}`,
  //   });
  //   break;
  // }
  //         return Promise.reject(error);
  //       }
  //     },
  // );
};
